import React from 'react';
import { Component } from 'react';

export class Cloudy extends Component {
render(){
  return (
    <div className="Icon">
      <svg version="1.1" id="cloudy" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24">
<g>
	<rect x="0" fill="none" width="24" height="24"/>
	<path fillRule="evenodd" clipRule="evenodd" fill="#E5E5E5" d="M20.8403,6.4685C20.274,4.0722,18.213,2.2941,15.75,2.2941
		c-2.8995,0-5.25,2.4616-5.25,5.5001c0,0.1964,0.0113,0.3896,0.03,0.5799C9.6345,8.7512,9,9.6665,9,10.7405
		c0,1.4097,1.0913,2.5535,2.4375,2.5535h9.3c1.8023,0,3.2625-1.5305,3.2625-3.4179C24,8.0252,22.5937,6.5268,20.8403,6.4685"/>
	<g>
		<g>
			<path fill="#FFFFFF" d="M3.6992,20.6764c-1.7637,0-3.1992-1.4297-3.1992-3.187c0-1.3047,0.7881-2.4639,2.0088-2.9531
				l0.3496-0.1401l-0.0391-0.375c-0.0264-0.2578-0.043-0.52-0.043-0.7856c0-4.103,3.3496-7.4414,7.4678-7.4414
				c3.4375,0,6.4141,2.3223,7.2402,5.6479l0.0918,0.3672l0.3779,0.0117c2.417,0.0767,4.3105,2.0186,4.3105,4.4209
				c0,2.4453-1.9971,4.4346-4.4512,4.4346H3.6992z"/>
			<path fill="#1D1D33" d="M10.2441,6.2941c3.2066,0,5.9842,2.1664,6.7547,5.2684l0.1824,0.7346l0.7565,0.0239
				c2.1459,0.0677,3.827,1.7899,3.827,3.9207c0,2.1697-1.7726,3.9348-3.9514,3.9348H3.6993C2.2109,20.1764,1,18.9711,1,17.4894
				c0-1.0995,0.6649-2.0764,1.694-2.4888L3.3945,14.72l-0.0778-0.7506c-0.027-0.261-0.0402-0.5011-0.0402-0.7341
				C3.2765,9.4079,6.4021,6.2941,10.2441,6.2941 M10.2441,5.2941c-4.4004,0-7.9677,3.5543-7.9677,7.9412
				c0,0.2836,0.0171,0.5627,0.0455,0.8372C0.963,14.6171,0,15.9387,0,17.4894c0,2.0353,1.6561,3.687,3.6993,3.687h14.1141
				c2.7352,0,4.9514-2.2099,4.9514-4.9348c0-2.6729-2.1342-4.8361-4.7954-4.9202C17.1099,7.8614,13.9821,5.2941,10.2441,5.2941
				L10.2441,5.2941z"/>
		</g>
	</g>
</g>
</svg>
           
    </div>
  );
}
}
export default Cloudy;